import LucidMascot from "@/assets/images/lucid-mascot.png";
import { DotLottiePlayer } from "@dotlottie/react-player";
import "@dotlottie/react-player/dist/index.css";
import * as Dialog from "@radix-ui/react-dialog";
import Image from "next/legacy/image";
import React from "react";
import { Button } from "../ui/button";

const RegisterEventSuccess = ({ isOpen, setOpen, email }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay asChild>
          <>
            <div className='fixed inset-0 z-[89] w-screen h-screen bg-background/80 backdrop-blur-sm'></div>
            <div className='fixed top-0 z-[89] left-0 w-full h-full lg:flex'>
              <div className='hidden w-full lg:inline'>
                <DotLottiePlayer
                  autoplay
                  loop
                  mode='normal'
                  src='https://lottie.host/d32eae98-9229-4dd2-8832-55c0eb02a2ea/30DNE5oGCm.lottie'
                />
              </div>
              <div className='w-full'>
                <DotLottiePlayer
                  autoplay
                  loop
                  mode='normal'
                  src='https://lottie.host/d32eae98-9229-4dd2-8832-55c0eb02a2ea/30DNE5oGCm.lottie'
                />
              </div>
            </div>
          </>
        </Dialog.Overlay>
        <Dialog.Content className='fixed bg-white text-background left-[50%] top-[50%] z-[99] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-4 lg:p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full'>
          <div className='text-center'>
            <div className='relative mx-auto h-24 aspect-[199/320] mb-3 -mt-16'>
              <Image
                src={LucidMascot.src}
                alt=''
                layout={"fill"}
                objectFit={"cover"}
              />
            </div>
            <p className='text-xl font-semibold tracking-tight lg:leading-tight lg:text-2xl'>
              Thank you for Signing Up!
            </p>
            <p className='mt-3 text-sm leading-snug'>
              Please enjoy the event!
            </p>
            {email && (
              <div className='mt-4 p-3 bg-gradient-to-r from-yellow-1/10 to-red-1/10 border border-yellow-1/20 rounded-lg'>
                <p className='text-sm leading-relaxed'>
                  Please check your email at <span className='font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-1 to-red-1'>{email}</span> for account information and your coupon code.
                </p>
              </div>
            )}
            <Button
              onClick={() => setOpen(false)}
              variant='secondary'
              className='w-full mt-4'
            >
              Close
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default RegisterEventSuccess;
